import { useLocalObservable } from 'mobx-react-lite';
import { useNavigate, useParams } from 'react-router-dom';

import { RouterLink } from 'APP/router/constants';
import { buildPath } from 'APP/router/helpers/buildPath';
import { ProjectName } from 'CONFIG_TYPES';

import { UnauthorizedRouts } from '../UnauthorizedView.constants';

interface ICallFinishedPresenter {
  onJoinAgain: () => void;
  isShowLogo: boolean;
}

export const useCallFinishedPresenter = (): ICallFinishedPresenter => {
  const params = useParams();
  const navigate = useNavigate();

  const presenter = useLocalObservable<ICallFinishedPresenter>(() => ({
    onJoinAgain(): void {
      navigate(
        buildPath([RouterLink.Unauthorized, UnauthorizedRouts.CallInvitation], {
          channelId: params.channelId,
        }),
        { replace: true }
      );
    },
    get isShowLogo(): boolean {
      return PROJECT_NAME === ProjectName.Cowork;
    },
  }));

  return presenter;
};
